/*
 * Nome do produto, em um lugar só.
 *
 * MARK V é a marca do Design System (tokens, tipografia, o monograma V). O
 * produto que a pessoa abre e usa chama Compass. As duas coisas convivem: o
 * símbolo é MARK V, o wordmark ao lado dele é o nome do produto.
 *
 * Existe como constante porque já divergiu: a Sidebar escrevia COMPASS
 * enquanto o splash de boot e as telas de auth escreviam MARK V, e o loader
 * animado do boot acabou anunciando o nome errado.
 *
 * O visual do wordmark continua vindo da classe .markv-wordmark (Gontserrat
 * 200 + tracking largo + uppercase): o nome mudou, o fundamento visual não.
 * Escrito em caixa normal de propósito, porque quem sobe para maiúscula é o
 * CSS; assim o leitor de tela lê "Compass" em vez de soletrar.
 */
export const PRODUTO = "Compass"
